export enum RimmEntityType {
  commodity = 'commodity',
  packageType = 'packageType',
  packageClass = 'packageClass',
  country = 'country',
  company = 'company',
  termsOfDelivery = 'termsOfDelivery',
  exchangeRate = 'exchangeRate',
  port = 'port',
  attachedDocument = 'attachedDocument',
  unitOfMeasurement = 'unitOfMeasurement',
  ministry = 'ministry',
  declarant = 'declarant',
  customsOffice = 'customsOffice',
  modeOfTransport = 'modeOfTransport',
  treatmentType = 'treatmentType',
  chemicalGoods = 'chemicalGoods',
}

export enum RimmSubEntityType {
  ministryDepartments = 'ministryDepartments',
  accuracies = 'accuracies',
}
